<template>
  <div class="animated fadeIn reg" ref="wrapper">
    <div class="kt-portlet kt-portlet--mobile" style="position:relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div
            class="d-flex flex-row justify-content-between align-items-center"
            style="margin-bottom: 2em"
          >
            <div style="width: 50%">
              <div>{{ company.name }}</div>
              <div>{{ $t("Social Headquarters") }}: {{ company.address }}</div>
              <div>{{ $t("Reg. No. Trade Register") }}: {{ company.cui }}</div>
              <div>
                {{ $t("Unique Reg. Code") }}: {{ company.registration_number }}
              </div>
              <div>
                {{ $t("License to organize betting activity") }}:
                {{ company.license_number }}
              </div>
            </div>
            <div>
              <div class="text-right">{{ $t("Date") }}</div>
              <h3 class="text-right">{{ reportDate }}</h3>
            </div>
          </div>
          <div
            class="mb-4 d-flex flex-row justify-content-between align-items-center"
          >
            <div>
              <div>{{ $t("Agency") }}</div>
              <strong>{{ shopName }}</strong>
            </div>
            <h2 class="text-center">{{ $t("CASH REGISTER") }}</h2>
            <div class="text-right print-display">
              {{ $t("Printed") }}: {{ datePrint.format("HH:mm, DD/MM/YYYY") }}
            </div>
          </div>
          <div class="mt-2">
            <b-table
              id="cash-register-table"
              :busy.sync="isBusy"
              show-empty
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :bordered="true"
              v-model="copy"
              :items="productsProvider"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              foot-clone
            >
              <template v-slot:head(act)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(explanations)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(receipts)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(payments)="data">{{
                $t(data.label)
              }}</template>

              <template v-slot:empty="scope">
                <div class="text-center">{{ $t(scope.emptyText) }}</div>
              </template>

              <template v-slot:top-row>
                <td colspan="3" class="text-right">
                  {{ $t("Balance the previous day") }}
                </td>
                <td>{{ round(balancePreviousDay) }}</td>
                <td></td>
              </template>
              <template v-slot:bottom-row>
                <td colspan="3" class="text-right">{{ $t("Subtotal") }}</td>
                <td>{{ round(subtotalIn) }}</td>
                <td>{{ round(subtotalOut) }}</td>
              </template>
              <template v-slot:foot(index)>
                <span></span>
              </template>
              <template v-slot:foot(act)>
                <span></span>
              </template>
              <template v-slot:foot(explanations)>
                <div class="text-right">
                  <strong>{{ $t("Total") }}</strong>
                </div>
              </template>
              <template v-slot:foot(receipts)>
                <strong>{{ round(total) }}</strong>
              </template>
              <template v-slot:foot(payments)>
                <span></span>
              </template>

              <template v-slot:cell(payments)="data">{{
                round(data.value)
              }}</template>
              <template v-slot:cell(receipts)="data">{{
                round(data.value)
              }}</template>
            </b-table>
          </div>
          <div>
            <div>
              {{ $t("Total Z on the cash register") }}: {{ round(totalZ) }}
            </div>
          </div>

          <div v-if="devices && devices.length > 0">
            <div
              class="mb-4 d-flex flex-row justify-content-between align-items-center"
            >
              <div></div>
              <h4 class="text-center">{{ $t("TERMINALS") }}</h4>
              <div></div>
            </div>
            <div class="mt-2">
              <b-table
                id="terminals-device-subtable"
                :busy.sync="isBusy"
                show-empty
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :bordered="true"
                v-model="copy"
                :items="devices"
                :fields="fields"
                :current-page="1"
                :per-page="999"
              >
                <template v-slot:head(act)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(explanations)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(receipts)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(payments)="data">{{
                  $t(data.label)
                }}</template>

                <template v-slot:empty="scope">
                  <div class="text-center">{{ $t(scope.emptyText) }}</div>
                </template>

                <template v-slot:cell(payments)="data">{{
                  round(data.value)
                }}</template>
                <template v-slot:cell(receipts)="data">{{
                  round(data.value)
                }}</template>
              </b-table>
            </div>
          </div>

          <div>
            <div>
              {{ $t("Cashier") }}:
              <strong>{{ cashiers }}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import startCase from "@/shared/strings";
import { errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import TableFilters from "@/components/TableFilters";
import timeFormat from "@/shared/timeFormat";

function unescape(str) {
  return (str + "===".slice((str.length + 3) % 4))
    .replace(/-/g, "+")
    .replace(/_/g, "/");
}

function decode(str, encoding) {
  return Buffer.from(unescape(str), "base64").toString(encoding || "utf8");
}

export default {
  name: "cashRegister",
  mixins: [tableMixin],
  components: {
    PaginationSelect,
    DropdownColumns,
    TableFilters
  },
  data: function() {
    return {
      tableName: "cashRegister",

      isBusy: false,
      fields: [
        {
          key: "index",
          label: "No. Crt",
          sortable: false,
          ignore: true,
          class: "mw-select"
        },
        {
          key: "act",
          label: "Act",
          sortable: false,
          ignore: true,
          class: ""
        },
        {
          key: "explanations",
          label: "Explanations",
          sortable: false,
          ignore: true,
          class: ""
        },
        {
          key: "receipts",
          label: "Receipts",
          sortable: false,
          ignore: true,
          class: ""
        },
        {
          key: "payments",
          label: "Payments",
          sortable: false,
          ignore: true,
          class: ""
        }
      ],
      sortBy: "",
      sortDesc: true,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      copy: null,
      addLabel: "",

      dateEnd: null,
      dateField: null,
      dateStart: null,
      exactFields: [],
      exactValues: [],
      fieldsExp: [],
      likeFields: [],
      likeValues: [],

      balancePreviousDay: 0,
      subtotalIn: 0,
      subtotalOut: 0,
      total: 0,

      cashiers: "",

      shopName: "",
      shopID: "",
      company: {
        name: "",
        address: "",
        cui: "",
        registration_number: "",
        license_number: ""
      },

      scrollHeight: 0,
      datePrint: moment(),

      totalZ: 0,
      devices: []
    };
  },
  computed: {
    reportDate() {
      if (this.dateStart) {
        if (moment(this.dateStart).isSame(moment(), "day")) {
          return `${this.mom(this.dateStart).format("HH:mm")}, ${this.mom(
            this.dateStart
          ).format("D")} ${this.$t(
            this.mom(this.dateStart).format("MMMM")
          )} ${this.mom(this.dateStart).format("YYYY")}`;
        }
        return `${this.mom(this.dateStart).format("D")} ${this.$t(
          this.mom(this.dateStart).format("MMMM")
        )} ${this.mom(this.dateStart).format("YYYY")}`;
      }
      return "";
    }
  },

  mounted() {
    let data = this.$router.history.current.query.data;
    data = decode(data);
    const queryParms = JSON.parse(data);

    this.dateField = queryParms.dateField;
    this.dateStart = queryParms.dateStart;
    this.dateEnd = queryParms.dateEnd;
    this.exactFields = queryParms.exactFields ? queryParms.exactFields : [];
    this.exactValues = queryParms.exactValues ? queryParms.exactValues : [];

    const index = this.exactFields.indexOf("shop_id");
    if (index > -1) {
      this.shopID = this.exactValues[index][0];
    }

    this.fieldsExp = queryParms.fields ? queryParms.fields : [];
    this.likeFields = queryParms.likeFields ? queryParms.likeFields : [];
    this.likeValues = queryParms.likeValues ? queryParms.likeValues : [];
    this.page = parseInt(queryParms.page);
    this.rowsPerPage = parseInt(queryParms.rowsPerPage);

    this.$store.dispatch("global/setLanguage", queryParms.lang);

    const self = this;
    this.intervalID = window.setInterval(() => {
      if (self.$refs.wrapper) {
        const newHeight = self.$refs.wrapper.scrollHeight;
        if (newHeight != self.scrollHeight) {
          self.scrollHeight = newHeight;
          self.sendMessage(
            JSON.stringify({ type: "resize", height: newHeight })
          );
        }
      }
    }, 100);

    this.onMessageCB = this.onMessage.bind(this);
    this.bindEvent(window, "message", this.onMessageCB);
  },
  destroyed() {
    window.clearInterval(this.intervalID);
    this.unbindEvent(window, "message", this.onMessageCB);
  },
  methods: {
    mom(val) {
      return moment(val);
    },
    refresh() {
      this.$root.$emit("bv::refresh::table", "cash-register-table");
      this.$root.$emit("bv::refresh::table", "terminals-device-subtable");
    },

    productsProvider(ctx, cbf) {
      const filteredrowsp = [];
      this.provider(ctx, rows => {
        if (rows.length > 0) {
          rows.forEach(row => {
            if (row.subtable == "products") {
              filteredrowsp.push(row);
            }
          });
        }
        cbf(filteredrowsp);
      });
      return null;
    },

    devicesProvider(ctx, cbf) {
      const filteredrowsd = [];
      this.provider(ctx, rows => {
        if (rows.length > 0) {
          rows.forEach(row => {
            if (row.subtable == "devices") {
              filteredrowsd.push(row);
            }
          });
        }
        cbf(filteredrowsd);
      });
      return null;
    },

    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const paginationData = this.buildPagination();
      const shopByID = this.$store.getters["cache/shopByID"];

      Promise.all([
        this.$store.dispatch("cache/fetch", "shops").catch(e => e)
      ]).finally(() => {
        this.$store
          .dispatch("cashRegister/fetch", paginationData)
          .then(resp => {
            /*
            // hardcoded test response override:
            resp={"success":true,"data":{"cashiers":null,"company":{"eid":"idHLDlcZlgL94MRmVts1dQ","uuid":"04301c5a-6b6c-4694-aaf5-f81bf665498c","name":"DREAM BETTING SRL","cui":"40594816","registration_number":"J40/4671/2019","address":"Bucuresti, sector 2, Calea Mosilor nr. 158, Modul P167, parter","license_number":"Decizia ONJN nr. 815 din 29.03.2019","ticket_footer_text":""},
            "products":[
              {"in":0,"in_tax":0,"out":0,"out_tax":0,"product_desc":"Lotto","product_id":"idHLDlcZlgL94MRmVts1dQ","product_name":"Lotto","product_z_include":true},
              {"in":0,"in_tax":0,"out":0,"out_tax":0,"product_desc":"Online Cash Transactions","product_id":"AV6VmJjVIwFckk0TQYWLkQ","product_name":"OnlineCash","product_z_include":false},
              {"in":0,"in_tax":0,"out":0,"out_tax":0,"product_desc":"Cash operations","product_id":"","product_name":"Cash operations","product_z_include":false},
              {"in":0,"in_tax":0,"out":0,"out_tax":0,"product_desc":"EPOS transactions","product_id":"","product_name":"EPOS transactions","product_z_include":false},
              {"in":42,"in_tax":0,"out":22,"out_tax":0,"product_desc":"Devices","product_id":"","product_name":"Devices","product_z_include":false},
              ],
            "devices":[
              {"in":0,"in_tax":0,"out":0,"out_tax":0,"product_desc":"DTEST Lotto","product_id":"idHLDlcZlgL94MRmVts1dQ","product_name":"Lotto","product_z_include":true},
              {"in":0,"in_tax":0,"out":0,"out_tax":0,"product_desc":"DTEST Online Cash Transactions","product_id":"AV6VmJjVIwFckk0TQYWLkQ","product_name":"OnlineCash","product_z_include":false},
              {"in":0,"in_tax":0,"out":0,"out_tax":0,"product_desc":"DTEST Cash operations","product_id":"","product_name":"Cash operations","product_z_include":false},
              {"in":0,"in_tax":0,"out":0,"out_tax":0,"product_desc":"DTEST EPOS transactions","product_id":"","product_name":"EPOS transactions","product_z_include":false}],
            "shop_balance":4412.73,"total_hold":0,"total_in":0,"total_in_tax":0,"total_out":0,"total_out_tax":0}};
            */

            const shop = shopByID(this.shopID);
            if (shop) {
              this.shopName = shop.name;
            }
            if (resp.data.company) {
              this.company = { ...this.company, ...resp.data.company };
            }
            this.balancePreviousDay = resp.data.shop_balance
              ? resp.data.shop_balance
              : 0;
            this.subtotalIn = resp.data.total_in ? resp.data.total_in : 0;
            this.subtotalOut = resp.data.total_out ? resp.data.total_out : 0;
            this.total =
              this.balancePreviousDay + this.subtotalIn - this.subtotalOut;

            if (resp.data.cashiers && resp.data.cashiers.length) {
              let tmp = "";
              const len = resp.data.cashiers.length - 1;
              resp.data.cashiers.forEach((cashier, index) => {
                tmp += `${cashier.name} ${cashier.surname} (${
                  cashier.username
                })${len !== index ? ", " : ""}`;
              });
              this.cashiers = tmp;
            }

            let index = 1;
            const rowsIn = [];
            const rowsOut = [];

            // always display placeholder terminal device totals at very end of products list
            const placeholderIndexValue = 99999; // will be replaced at the end
            const rememberTD = {
              act: this.$t("Monetary"),
              explanations: this.$t("Terminals Deposits"),
              receipts: 0,
              subtable: "products",
              index: placeholderIndexValue
            };
            const rememberTW = {
              act: this.$t("Deposit"),
              explanations: this.$t("Terminals Withdrawals"),
              payments: 0,
              subtable: "products",
              index: placeholderIndexValue
            };

            resp.data.products.forEach(row => {
              let showRow = true;
              let act = this.$t("Monetary");
              let explanations = `${this.$t("Sales revenue")} ${this.$t(
                row.product_desc
              )}`;

              if (row.product_name === "Cash operations") {
                act = this.$t(row.product_name);
                explanations = this.$t("Supply");

                this.total = this.total + row.in;
                this.subtotalIn = this.subtotalIn + row.in;
              }

              if (row.product_name === "Devices") {
                showRow = false;
                rememberTD.receipts = row.in;
                this.total = this.total + row.in;
                this.subtotalIn = this.subtotalIn + row.in;
              }

              if (row.product_name === "EPOS transactions") {
                showRow = false;
              }
              if (row.product_z_include) {
                this.totalZ += row.in;
              }
              if (row.in === 0) {
                showRow = false;
              }
              if (showRow) {
                rowsIn.push({
                  act: act,
                  explanations: explanations,
                  receipts: row.in,
                  subtable: "products",
                  index
                });
                index++;
              }
            });
            resp.data.products.forEach(row => {
              let showRow = true;
              let act = this.$t("Payment provision");
              let explanations = `${this.$t("Payment of prizes")} ${this.$t(
                row.product_desc
              )}`;

              if (
                row.product_name === "Cash operations" ||
                row.product_name === "EPOS transactions"
              ) {
                act = this.$t(row.product_name);
                explanations = this.$t("Deposit");

                this.total = this.total - row.out;
                this.subtotalOut = this.subtotalOut + row.out;
              }

              if (row.product_name === "Devices") {
                showRow = false;
                rememberTW.payments = row.out;
                this.total = this.total - row.out;
                this.subtotalOut = this.subtotalOut + row.out;
              }

              if (row.product_name === "EPOS transactions") {
                explanations = this.$t("EPOS Deposit");
              }
              if (row.out === 0) {
                showRow = false;
              }

              if (showRow) {
                rowsOut.push({
                  act: act,
                  explanations: explanations,
                  payments: row.out,
                  subtable: "products",
                  index
                });
                index++;
              }
            });

            // fill in proper index value
            // rememberTD.index = index;
            // rememberTW.index = index + 1;
            const rows = [...rowsIn, ...rowsOut];

            if (rememberTD.receipts > 0) {
              rememberTD.index = index;
              rows.push(rememberTD);
              index++;
            }
            if (rememberTW.payments > 0) {
              rememberTW.index = index;
              rows.push(rememberTW);
            }

            // reset for devices subtable
            index = 1;
            const drowsIn = [];
            const drowsOut = [];

            if (resp.data.devices && resp.data.devices.length > 0) {
              resp.data.devices.forEach(row => {
                let showRow = true;
                let act = this.$t("Monetary");
                let explanations = `${this.$t("Sales revenue")} ${this.$t(
                  row.product_desc
                )}`;

                if (row.product_name === "Cash operations") {
                  act = this.$t(row.product_name);
                  explanations = this.$t("Supply");
                }
                if (row.in === 0) {
                  showRow = false;
                }
                if (showRow) {
                  drowsIn.push({
                    act: act,
                    explanations: explanations,
                    receipts: row.in,
                    subtable: "devices",
                    index
                  });
                  index++;
                }
              });
              resp.data.devices.forEach(row => {
                let showRow = true;
                let act = this.$t("Payment provision");
                let explanations = `${this.$t("Payment of prizes")} ${this.$t(
                  row.product_desc
                )}`;

                if (
                  row.product_name === "Cash operations" ||
                  row.product_name === "EPOS transactions"
                ) {
                  act = this.$t(row.product_name);
                  explanations = this.$t("Deposit");
                }
                if (row.out === 0) {
                  showRow = false;
                }

                if (showRow) {
                  drowsOut.push({
                    act: act,
                    explanations: explanations,
                    payments: row.out,
                    subtable: "devices",
                    index
                  });
                  index++;
                }
              });
            }

            this.devices = [...drowsIn, ...drowsOut];

            callback(rows);
          })
          .catch(err => {
            this.totalRows = 0;
            callback([]);
          })
          .finally(() => {
            loading.close();
          });
      });
      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    buildPagination() {
      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage
      };

      paginationData.likeValues = [];
      paginationData.likeFields = [];

      if (this.sortBy) {
        paginationData.sortBy = [this.sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      if (this.exactFields.length && this.exactValues.length) {
        paginationData.exactFields = this.exactFields;
        paginationData.exactValues = this.exactValues;
      } else {
        paginationData.exactFields = [];
        paginationData.exactValues = [];
      }

      if (this.dateStart && this.dateField) {
        paginationData.dateField = this.dateField;
        paginationData.dateStart = this.dateStart;
        paginationData.dateEnd = this.dateEnd;
      } else {
        paginationData.dateField = this.dateField;
        paginationData.dateStart = moment().startOf("month");
        paginationData.dateEnd = moment().endOf("month");
      }

      return paginationData;
    },
    rowClicked(item, index, event) {},
    redirect() {},
    onMessage(e) {
      let data = {};
      try {
        data = JSON.parse(e.data);
      } catch (err) {
        // noop
      }
      if (data) {
        if (data.type && data.type == "print") {
          this.datePrint = moment();
          this.$nextTick(() => {
            window.print();
          });
        }
      }
    },
    bindEvent(element, eventName, eventHandler) {
      if (element.addEventListener) {
        element.addEventListener(eventName, eventHandler, false);
      } else if (element.attachEvent) {
        element.attachEvent("on" + eventName, eventHandler);
      }
    },
    unbindEvent(element, eventName, eventHandler) {
      if (element.removeEventListener) {
        element.removeEventListener(eventName, eventHandler, false);
      } else if (element.attachEvent) {
        element.detachEvent("on" + eventName, eventHandler);
      }
    },
    sendMessage(msg) {
      // Make sure you are sending a string, and to stringify JSON
      window.parent.postMessage(msg, "*");
    }
  }
};
</script>
<style lang="css">
body {
  background-color: #fff !important;
}
@page {
  size: A4;
  margin: 0;
}
@media print {
  html,
  body {
    width: 210mm;
    height: 297mm;
  }
}
</style>
<style lang="scss" scoped>
.reg {
  & /deep/ #cash-register-table tfoot th {
    border: 0 !important;
  }

  & /deep/ #terminals-device-subtable tfoot th {
    border: 0 !important;
  }

  & /deep/ .mw-select {
    width: 30px !important;
  }
}
.kt-portlet {
  margin-bottom: 0;
  border-radius: 0;
  color: #000;
}
h2,
h3 {
  color: #000;
}
.print-display {
  opacity: 0;
}
@media print {
  .kt-portlet {
    font-size: 20px;
  }
  .print-display {
    opacity: 1;
  }
}
</style>
